import { IonicPage } from 'ionic-angular';
import { Component } from '@angular/core';
import { AppConfig } from '../../../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-vessel-crew-edit',
  templateUrl: 'vessel-crew-edit.html',
})
export class VesselCrewEditPage {

  config = AppConfig.settings;

  constructor() {
  }

  ionViewDidLoad() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/DPR Pages/vessel-crew/vessel-crew-edit/vessel-crew-edit.ts